<template>
  <div>
    <h1>{{ msg }}</h1>
    <h3>{{ registerLoadingText }}</h3>

    <form @submit.prevent="register">
      <label for="firstName">First Name</label>
      <div>
        <input id="firstName" type="text" v-model="firstName" required autofocus>
      </div>
      <label for="lastName">Last Name</label>
      <div>
        <input id="lastName" type="text" v-model="lastName" required autofocus>
      </div>
      <label for="email">Email</label>
      <div>
        <input id="email" type="email" v-model="email" required>
      </div>
      <label>Guesty Token</label>
      <div>
        <input id="token" v-model="guestyToken">
      </div>
      <label>Guesty Secret</label>
      <div>
        <input id="secret" type="password" v-model="guestySecret">
      </div>
      <label>Lodgify API Key</label>
      <div>
        <input id="lodgifyAPIKey" v-model="lodgifyAPIKey">
      </div>
      <label>KOPA Company Id</label>
      <div>
        <input id="companyId" v-model="companyId">
      </div>
      <div>
        <button type="submit">Sign up</button>
      </div>
    </form>

  </div>
</template>

<script>
export default {
  name: 'OperatorRegistration',
  props: {
    msg: String
  },
  data: () => ({
    firstName: "",
    lastName: "",
    email: "",
    guestyToken: "",
    guestySecret: "",
    lodgifyAPIKey: "",
    companyId: "",
    registerLoadingText: ""
  }),
  methods: {
    register() {
      let data = {};
      if (this.guestyToken.length > 0) {
        data = {
          "firstName": this.firstName,
          "lastName": this.lastName,
          "email": this.email,
          "accountInfo": {
            "guesty": {
              "username": this.guestyToken,
              "password": this.guestySecret,
            }
          }
        };
      } else if (this.lodgifyAPIKey.length > 0) {
        data = {
          "firstName": this.firstName,
          "lastName": this.lastName,
          "email": this.email,
          "accountInfo": {
            "lodgify": {
              "api_key": this.lodgifyAPIKey
            }
          }
        };
      } else if (this.companyId.length > 0) {
        data = {
          "firstName": this.firstName,
          "lastName": this.lastName,
          "email": this.email,
          "accountInfo": {
            "kopa": {
              "company_id": this.companyId
            }
          }
        };
      }
      this.registerLoadingText = "Setting your account up...";

      fetch("https://us-east4-elite-pointer-290612.cloudfunctions.net/new-operator-onboarding", {
        method: 'POST',
        body: JSON.stringify(data),
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json"
        }
      }).then(res => res.statusCode)
          .then(statusCode => {
            console.log(statusCode);

            this.registerLoadingText = "Finished setting up your account!"
          });
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}
</style>
